module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-content-block', {
    staticClass: "blueHeader"
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('md-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "default"
    },
    domProps: {
      "textContent": _vm._s('close')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    },
    slot: "default"
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area"
  }, [_c('mu-content-block', {
    staticStyle: {
      "padding": "16px 24px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('message.foodDiaryLandingExplain')) + "\n\n      "), (_vm.recents.length == 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.$t('message.foodDiaryRecentsEmpty')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.recents.length > 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.$t('message.foodDiaryHasRecents')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('mu-content-block', {
    staticStyle: {
      "padding": "0px 24px 24px 24px"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": _vm.recents.length > 0 ? '50' : '100',
      "tablet": _vm.recents.length > 0 ? '50' : '100',
      "width": "100"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-paper', {
    staticClass: "paperCard",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-content-block', {
    staticClass: "landingCard",
    nativeOn: {
      "click": function($event) {
        return _vm.userDecidesTo('a')
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "58px"
    },
    attrs: {
      "src": "static/food-diary/search.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelBelowImg"
  }, [_vm._v(_vm._s(_vm.$t('message.searchText')))])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-paper', {
    staticClass: "paperCard",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-content-block', {
    staticClass: "landingCard",
    nativeOn: {
      "click": function($event) {
        return _vm.userDecidesTo('mm')
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "58px"
    },
    attrs: {
      "src": "static/food-diary/baseline-restaurant_menu-24px.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelBelowImg"
  }, [_vm._v(_vm._s(_vm.$t('message.foodDiaryLoadFromMyMeals')))])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "yesterday-btn",
    attrs: {
      "icon": "refresh",
      "label": _vm.$t('message.foodDiaryRepeatYesterdayMeal'),
      "disabled": !_vm.isDateToday,
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyYesterdaysMeal.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "mobileTop",
    attrs: {
      "desktop": _vm.recents.length > 0 ? '50' : '100',
      "tablet": _vm.recents.length > 0 ? '50' : '100',
      "width": "100"
    }
  }, [_c('mu-card', [_c('mu-list', {
    attrs: {
      "id": "recents"
    }
  }, _vm._l((_vm.recents), function(item, index) {
    return _c('mu-list-item', {
      key: 'recent-' + index,
      attrs: {
        "title": item.food_name
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectRecent(item)
        }
      }
    }, [_c('mu-icon', {
      staticClass: "left8",
      attrs: {
        "slot": "left",
        "value": "history"
      },
      slot: "left"
    })], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a4d9fd3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FoodDiary/LandingDialog/LandingDialog.vue
// module id = 3618
// module chunks = 1